import { render, staticRenderFns } from "./RoomTypesList.vue?vue&type=template&id=06062d0d&"
import script from "./RoomTypesList.vue?vue&type=script&lang=js&"
export * from "./RoomTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports